import React from 'react';
import { Link } from "react-router-dom";

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faInstagram, faGithub} from '@fortawesome/free-brands-svg-icons';

import {DisplayTimeZone, DisplayLanguage} from 'Components/Settings';

import {translation} from 'Services/TranslationHelpers';
import { asset } from "../../../Services/BaseHelpers";

/**
 * @function Footer
 * @return {JSX.Element}
 * @constructor
 */
const Footer = () => {
    return (
        <footer className="bg-app-blue py-8 px-2 md:px-0 text-center text-white">
            <p className="text-3xl font-bold mb-4">QUESTIONS?</p>
            <p className="text-xl font-bold mb-20">If you have any questions please visit the <Link to="/faq" className="underline">FAQs</Link> page</p>

            <img src={asset('images/mini-logo-white.png')} alt="logo" className="w-20 mx-auto mb-2" />
            <p className="font-bold text-sm">
                &copy; MINI {new Date().getFullYear()}
            </p>
        </footer>
    );
};

export default Footer;
